import {useFetchBenchesData} from 'components/customer/BTM/helper/useFetchBenchesData';
import {
    useGetExtraVariationsQuery,
    useGetJobCabinetVariationDetailsQuery,
} from 'components/customer/Job/store/jobApi';
import {useJobContext} from 'contexts';
import {useMemo} from 'react';
import {PartialJob} from 'shared/types/PartialJob';

export const useGetBenchVariations = () => {
    const {benches, isLoaded} = useFetchBenchesData();

    const variations = useMemo(() => {
        if (benches && benches.length > 0) {
            return benches
                .filter((bench) => bench.comment && bench.comment.length > 0)
                .map((bench) => ({
                    id: bench.id,
                    name: bench.variationName,
                    comment: bench.comment,
                    variation_cost: bench.variationCost,
                    jobBenchtopNumber: bench.jobBenchtopNumber,
                }));
        }

        return [];
    }, [benches]);

    return {
        isLoaded,
        variations,
    };
};

export const useGetExtraVariations = () => {
    const {job} = useJobContext() as PartialJob;
    const {data, isLoading, isFetching} = useGetExtraVariationsQuery(
        {
            jobId: job.id,
        },
        {
            skip: job?.id === undefined,
        }
    );

    const variations = useMemo(() => {
        if (data && data.length > 0 && job) {
            return data.map((variation) => ({
                id: variation.id,
                variation_cost: variation.cost,
                name: variation.name,
                removable: variation.removable,
                job_cabinet_appliance_id: variation.job_cabinet_appliance_id,
                product_label: variation.product_label,
                detail_label: variation.detail_label,
            }));
        }
        return [];
    }, [data, job]);

    return {
        isLoading,
        isFetching,
        variations,
    };
};

export const useGetProductVariations = () => {
    const {job} = useJobContext() as PartialJob;
    const {data, isLoading, isFetching} = useGetJobCabinetVariationDetailsQuery(
        {
            jobId: job.id,
        },
        {
            skip: job?.id === undefined,
        }
    );

    const variations = useMemo(() => {
        if (data && data.length > 0 && job) {
            return data.map((jobVariation) => ({
                id: Number(jobVariation.id),
                room_id: jobVariation.room_id,
                room_cab_number: jobVariation.room_cab_number,
                type_name: jobVariation.type_name,
                comment: jobVariation.comment,
                variation_cost: jobVariation.variation_cost,
            }));
        }
        return [];
    }, [data, job]);

    return {
        isLoading,
        isFetching,
        variations,
    };
};
